import { render, staticRenderFns } from "./intervene.vue?vue&type=template&id=2da91560&scoped=true&"
import script from "./intervene.vue?vue&type=script&lang=js&"
export * from "./intervene.vue?vue&type=script&lang=js&"
import style0 from "./intervene.vue?vue&type=style&index=0&id=2da91560&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da91560",
  null
  
)

export default component.exports